import state from './moduleBrandManagementState.js'
import mutations from './moduleBrandManagementMutations.js'
import actions from './moduleBrandManagementActions.js'
import getters from './moduleBrandManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

